import { compact } from 'lodash';

import { mergeEmissionStats } from '@/lib/models/emissions/utils/merge-emission-stats';
import { OptionModel } from '@/lib/models/option/types';
import { EmissionStats } from '@/types';

export const calcMainOptionEmissions = (options: OptionModel[]): EmissionStats | undefined => {
  const stats = compact(options.map((opt) => opt.emissions));
  return mergeEmissionStats(stats);
};
